import Icon from "@mdi/react"
import { mdiLaptop, mdiTruck, mdiCog, mdiTools, mdiAlert } from "@mdi/js"

import Link from "components/i18n/Link"

export const leftNavs = [
	{
		icon: <Icon path={mdiLaptop} size={1} color="#7ABFAC" />,
		titleByLanguage: { de: "Website", pl: "Strona internetowa" },
		descriptionByLanguage: {
			de: "Allgemeine Fragen zum Einkauf und dem Bestellablauf auf SafeHero.com.",
			pl: "Ogólne pytania dotyczące zakupów i procesu zamawiania na SafeHero.com.",
		},
		link: "website",
	},
	{
		icon: <Icon path={mdiTruck} size={1} color="#FFD462" />,
		titleByLanguage: { de: "Lieferung", pl: "Dostawa" },
		descriptionByLanguage: {
			de: "Hier finden Sie Antworten zu unseren Lieferkosten, Liefermethoden und Lieferzeiten.",
			pl: "Tutaj znajdziesz odpowiedzi na temat naszych kosztów dostawy, metod dostawy i czasu dostawy.",
		},
		link: "delivery",
	},
	{
		icon: <Icon path={mdiCog} size={1} color="#1B5C71" />,
		titleByLanguage: { de: "Technische Fragen", pl: "Pytania techniczne" },
		descriptionByLanguage: {
			de: "Fragen und Antworten zu unseren Tresorarten, den Sicherheitsstufen und den Brandschutzklassen.",
			pl: "Pytania i odpowiedzi dotyczące naszych typów sejfów, klas odporności na włamanie i odporności przeciwogniowej.",
		},
		link: "technical-questions",
	},
	{
		icon: <Icon path={mdiTools} size={1} color="#418389" />,
		titleByLanguage: { de: "Montage", pl: "Montaż" },
		descriptionByLanguage: {
			de: "Wichtige Informationen die Sie bei der Montage beachten sollten.",
			pl: "Ważne informacje, których należy przestrzegać podczas instalacji.",
		},
		link: "assembly",
	},
	{
		icon: <Icon path={mdiAlert} size={1} color="#CF423B" />,
		titleByLanguage: { de: "Probleme", pl: "Problemy" },
		descriptionByLanguage: {
			de: "Bei Technischen Problemen oder defekten finden Sie hier Informationen und Antworten.",
			pl: "W przypadku problemów technicznych lub usterek, znajdziesz tutaj informacje i odpowiedzi.",
		},
		link: "problems",
	},
]

export const websiteFAQs = [
	{
		questionByLanguage: {
			de: "Tresor im Internet bestellen - Ist das sicher?",
			pl: "Zamawianie sejfu przez internet - czy to bezpieczne?",
		},
		answerByLanguage: {
			de: (
				<>
					<p>Selbstverständlich!</p>
					<p>
						Bei uns profitieren Sie von allen Serviceleistungen eines lokalen Händlers
						und sparen dabei eine Menge Geld:
					</p>
					<ul>
						<li>
							Beratung durch unsere Spezialisten mit langjähriger Erfahrung in der
							Tresorbranche
						</li>
						<li>Lieferung bis an den Verwendungsort und Montage Ihres Tresors</li>
						<li>Sonderlösungen bei Lieferung und Montage? Kein Problem!</li>
						<li>
							Sämtliche Daten vertraulich gehandhabt und unterliegen
							selbstverständlich der DSGVO.
						</li>
					</ul>
				</>
			),
			pl: (
				<>
					<p>Oczywiście!</p>
					<p>
						Z nami korzystasz z wszystkich usług lokalnego dealera i jednocześnie
						zaoszczędzić sporo pieniędzy:
					</p>
					<ul>
						<li>
							Porady naszych specjalistów z wieloletnim doświadczeniem w branży sejfów
						</li>
						<li>Dostawa pod adres wskazany w zamówieniu</li>
						<li>Wszystkie dane są traktowane jako poufne</li>
					</ul>
				</>
			),
		},
	},
	{
		questionByLanguage: {
			de: "Wie funktioniert der Bestellablauf?",
			pl: "Jak przebiega proces zamawiania?",
		},
		answerByLanguage: {
			de: (
				<>
					<p>
						Sie wählen den für Sie passenden Tresor aus. Bequem mit unserer Größensuche
						und Filterfunktion. Sollten Sie Hilfe bei der Auswahl des richtigen Tresors
						benötigen, schreiben Sie uns ein Mail oder rufen Sie uns an, wir helfen
						Ihnen gerne weiter!
					</p>
					<p>
						Bestellen Sie einen Tresor mit den von Ihnen gewünschten Optionen und legen
						Sie diesen in den Warenkorb. Bei der Konfiguration des Produktes werden
						Ihnen mögliche Lieferoptionen zur Auswahl gestellt.
					</p>
					<p>
						Wir bearbeiten Ihre Bestellung noch am selben Werktag und beauftragen den
						Tresor beim Hersteller.
					</p>
					<p>
						Vor Lieferung Frei Bordsteinkante werden Sie von der Spedition kurzfristig
						avisiert. Haben Sie das Vertragen an den Verwendungsort bzw. die Montage
						bestellt, wird ein fixer Termin ca. 1 Woche im Vorhinein vereinbart. Weitere
						Informationen zur Lieferung finden Sie hier:
					</p>
					<p>
						<Link href="/help/delivery">Lieferung und Montage</Link>
					</p>
				</>
			),
			pl: (
				<>
					<p>
						Wybierasz ten sejf, który najbardziej Ci odpowiada. Wygodnie z naszą
						wyszukiwarką i funkcją filtra. Jeśli potrzebujesz pomocy przy wyborze
						odpowiedniego sejfu, napisz do nas maila lub zadzwoń, chętnie Ci pomożemy!
					</p>
					<p>Zamów sejf z wybranymi opcjami i dodaj go do koszyka.</p>
					<p>
						Zamówienie realizujemy w tym samym dniu roboczym i zlecamy sejf do
						producenta.
					</p>
					<p>
						Przed dostawą pod wskazany adres zostaniesz powiadomiony przez firmę
						spedycyjną.
					</p>
					<p>
						<Link href="/help/delivery">Dostawa i montaż</Link>
					</p>
				</>
			),
		},
	},
	{
		questionByLanguage: {
			de: "Warum einen Tresor bei SafeHero kaufen?",
			pl: "Dlaczego warto kupić w SafeHero?",
		},
		answerByLanguage: {
			de: (
				<>
					<p>
						<strong>Alle namhaften Hersteller im Sortiment</strong>
					</p>
					<p>
						Durchsuchen Sie nicht unzählige Shops - Bei uns sind alle namhaften
						Hersteller vertreten, somit kann sehr einfach und bequem ein transparenter
						Vergleich angestellt werden.
					</p>
					<p>
						<strong>Tresorsuche nach Außenmaß</strong>
					</p>
					<p>
						Sie haben eine maximale Größenvorgabe? Dann sind Sie bei uns richtig, denn
						in jeder Kategorie können die Produkte mit Größenfilter eingegrenzt werden
					</p>
					<p>
						<strong>Kostenlose Lieferung</strong>
					</p>
					<p>
						Bei uns erfolgt die Lieferung Frei Bordsteinkante kostenlos innerhalb
						Deutschlands und Österreichs.
					</p>
					<p>
						<strong>Günstiger Montageservice</strong>
					</p>
					<p>
						Auch das Liefern an den Verwendungsort und die Montage des Tresors
						übernehmen wir gerne für Sie!
					</p>
				</>
			),
			pl: (
				<>
					<p>
						<strong>
							W naszej ofercie znajdziesz wszystkich renomowanych producentów
						</strong>
					</p>
					<p>
						Nie przeszukuj niezliczonych sklepów - u nas znajdziesz wszystkie znane
						marki, więc można łatwo i wygodnie dokonać porównania.
					</p>
					<p>
						<strong>Bezpieczne wyszukiwanie według wymiarów zewnętrznych</strong>
					</p>
					<p>
						Czy macie Państwo wymagania dotyczące maksymalnego wymiaru? W takim razie
						trafiłeś we właściwe miejsce, ponieważ w każdej kategorii można wyszukać
						produkty za pomocą filtra wymiarów.
					</p>
					<p>
						<strong>Darmowa dostawa</strong>
					</p>
					<p>
						Dostarczamy bezpłatnie pod wskazany w zamówieniu adres (dostawa pod budynek,
						do pierwszej przeszkody).
					</p>
				</>
			),
		},
	},
	{
		questionByLanguage: {
			de: "Kann ich auf Rechnung einkaufen?",
			pl: "Czy mogę kupić na fakturę?",
		},
		answerByLanguage: {
			de: (
				<p>
					Selbstverständlich! Gerne können Sie über unseren Partner Klarna auch auf
					Rechnung einkaufen.
				</p>
			),
			pl: (
				<p>
					Oczywiście! Zapraszamy również do zakupu na fakturę za pośrednictwem naszego
					partnera Klarna.
				</p>
			),
		},
	},
]

export const deliveryFAQs = [
	{
		questionByLanguage: { de: "Was kostet die Lieferung?", pl: "Jaki jest koszt dostawy?" },
		answerByLanguage: {
			de: (
				<p>
					Die Lieferung nach Deutschland und Österreich ist kostenlos frei Bordsteinkante.
					Bei einem Gewicht von unter 35 kg erfolgt die Zustellung mit einem Paketdienst
					bis zur Haustüre. Die Kosten für eine Lieferung bis zur Verwendungsstelle, sei
					es mit oder ohne Montage sind von Hersteller zu Hersteller unterschiedlich.
					Selbstverständlich trägt auch das Gewicht eine entscheidende Rolle. Weitere
					Infos zu den genauen Kosten bei einer Lieferung zur Verwendungsstelle erfahren
					Sie beim jeweiligen Produkt.
				</p>
			),
			pl: (
				<p>
					Dostawa do Polski jest bezpłatna pod wskazany w zamówieniu adres dla produktów o
					wadze powyżej 30kg. Jeśli waga zamówionego produktu jest mniejsza, dostawa
					zostanie zrealizowana wybraną firma kurierską do drzwi wejściowych.
				</p>
			),
		},
	},
	{
		questionByLanguage: {
			de: "Was ist mit Transport Frei Bordsteinkante gemeint?",
			pl: "Co należy rozumieć przez dostawę pod wskazany w zamówieniu adres?",
		},
		answerByLanguage: {
			de: (
				<p>
					Wir versenden alle Tresore kostenlos innerhalb Deutschlands und Österreichs.
					Tresore bis ca. 35 kg mit dem Paketdienst, Tresore ab 35 kg werden mit einer
					Linienspedition versendet. Die Linienspedition liefert den Tresor bis zum ersten
					Hindernis, z. B. Stufe vor der Haustüre. Darum auch die Bezeichnung „Frei
					Bordsteinkante“. Wir bieten Ihnen selbstverständlich auch an, den Tresor im Haus
					an die Verwendungsstelle zu transportieren.
				</p>
			),
			pl: (
				<p>
					Oznacza to dostawę pod budynek, do pierwszej przeszkody np. pierwszego stopnia
					przed drzwiami wejściowymi.
				</p>
			),
		},
	},
	{
		questionByLanguage: {
			de: "Wie lange sind die Lieferzeiten?",
			pl: "Jak długie są terminy dostaw?",
		},
		answerByLanguage: {
			de: (
				<p>
					Wir sind bemüht, die Lieferzeiten so exakt wie möglich anzugeben. Da wir viele
					Tresore direkt vom Hersteller aus versenden, bzw. der Tresor erst für Sie
					produziert wird, kann es in Ausnahmefällen zu einer Abweichung kommen!
				</p>
			),
			pl: (
				<p>
					Staramy się jak najdokładniej podać czas dostawy. Ponieważ wysyłamy sejfy
					bezpośrednio od producenta lub jeśli sejf jest produkowany dla Ciebie na
					zamówienie, w wyjątkowych przypadkach może wystąpić inny niż podany termin
					dostawy.
				</p>
			),
		},
	},
]

export const technicalQuestionsFAQs = [
	{
		questionByLanguage: {
			de: "Welchen Tresor soll ich wählen?",
			pl: "Który sejf powinienem wybrać?",
		},
		answerByLanguage: {
			de: (
				<>
					<p>
						Grundsätzlich sollte unterschieden werden, ob man nur einen Einbruchschutz,
						nur einen Feuerschutz oder beides in Kombination benötigt.
					</p>
					<p>
						&quot;Klassische&quot; Tresore, welche hohen Widerstand gegen
						Einbruchsversuche bieten, nennen sich Wertschutzschrank, Panzerschrank und
						manchmal auch Wert- oder Geldschrank. Diese Tresore haben meist die
						Sicherheitsstufen von 0 bis 6 nach EN1143-1. Je höher die Schutzklasse,
						desto länger benötigt der Einbrecher, den Tresor zu öffnen.
					</p>
					<p>
						Möbeltresore sind ebenfalls meist auch auf Einbruchschutz ausgerichtet,
						allerdings meist nur bis zu Sicherheitsklasse 1 erhältlich. Somit auch Ideal
						für den Privatgebrauch geeignet, da Möbeltresore sich durch innenliegende
						Türbänder auch gut in Möbel einbauen lassen.
					</p>
					<p>
						Dokumententresore bieten Schutz gegen Brandeinwirkung und haben meistens
						auch einen leichten Einbruchschutz vorzuweisen. Die maximale Temperatur,
						welche im Innenraum des Tresors nicht überschritten werden darf, ist so
						gewählt, dass Papierdokumenten danach noch lesbar sind.
					</p>
					<p>
						Datentresore bieten ebenfalls sehr guten Schutz vor Brandeinwirkung,
						allerdings ist die maximale Temperatur, welche im Innenraum des Tresors
						nicht überschritten werden darf so gewählt, dass Datenträger danach noch
						funktionsfähig sind.
					</p>
				</>
			),
			pl: (
				<>
					<p>
						Zasadniczo należy rozróżnić, czy potrzebna jest tylko ochrona przed
						włamaniem, tylko ochrona przeciwpożarowa, czy też obydwie jednocześnie.
					</p>
					<p>
						&quot;Klasyczne&quot; sejfy, zapewniające wysoką odporność na próby
						włamania, nazywane są sejfami na rzeczy wartościowe, szafami pancernymi, a
						czasem także sejfami na kosztowności lub pieniądze. Sejfy te mają zwykle
						klasy odporności od 0 do 6 wg EN1143-1. Im wyższa klasa ochrony, tym dłużej
						zajmuje włamywaczowi otwarcie sejfu.
					</p>
					<p>
						Sejfy meblowe są też zazwyczaj ukierunkowane na odporność przed włamaniem,
						ale zazwyczaj są dostępne tylko do 1. klasy bezpieczeństwa. Są one idealne
						do użytku prywatnego, ponieważ sejfy meblowe mogą być również w łatwy sposób
						zamontowane w meblach dzięki wewnętrznym zawiasom drzwiowym.
					</p>
					<p>
						Sejfy na dokumenty zapewniają ochronę przed skutkami pożaru i zazwyczaj
						posiadają również lekkie zabezpieczenia przed włamaniem. Maksymalna
						temperatura, której nie można przekroczyć wewnątrz sejfu, jest tak dobrana,
						aby dokumenty papierowe były nadal czytelne.
					</p>
					<p>
						Sejfy na dane również bardzo dobrze chronią przed skutkami pożaru, jednak
						maksymalna temperatura, której nie można przekroczyć we wnętrzu sejfu, jest
						tak dobrana, aby nośniki danych były po nim nadal sprawne.
					</p>
				</>
			),
		},
	},

	{
		questionByLanguage: {
			de: "Was bedeuten die Sicherheitsklassen und Brandschutzstufen?",
			pl: "Co oznaczają klasy odporności na włamanie oraz odporności przeciwogniowej?",
		},
		answerByLanguage: {
			de: (
				<>
					<p>
						Sicherheitsklassen, Brandschutzstufen, VdS, ECB-S, EN1143-1 - Was bedeutet
						das?
					</p>
					<p>
						Die Sicherheitsstufe gibt an, wie lange ein Einbrecher benötigt, um in den
						Innenraum des Tresors zu gelangen. Je höher die Sicherheitsklasse, desto
						höher der Schutz und damit auch die Versicherungssumme.
					</p>
					<p>
						Brandschutzstufen geben an, wie lange bei einer Brandeinwirkung die
						Temperatur im Innenraum des Tresors um eine gewisse Temperatur nicht
						überschritten wird.
					</p>
					<p>
						Die verschiedenen Schutzklassen werden zertifiziert, damit haben Sie die
						Sicherheit, dass die Anforderungen lt. der Norm EN1143-1 auch eingehalten
						werden.
					</p>
				</>
			),
			pl: (
				<>
					<p>
						Klasy odporności na włamanie oraz odporności przeciwogniowej, VdS, ECB-S,
						EN1143-1 - co to znaczy?
					</p>
					<p>
						Odporność na włamanie wskazuje, ile czasu zajmie włamywaczowi, aby dostać
						się do wnętrza sejfu. Im wyższa klasa odporności na włamanie, tym wyższa
						ochrona, a więc i suma ubezpieczenia.
					</p>
					<p>
						Poziom ochrony przeciwogniowej wskazuje, jak długo w przypadku pożaru nie
						zostanie przekroczona określona temperatura wewnątrz sejfu.
					</p>
					<p>
						Różne klasy ochrony są certyfikowane, dzięki czemu można mieć pewność, że
						spełnione są wymagania normy EN1143-1.
					</p>
				</>
			),
		},
	},
	{
		questionByLanguage: {
			de: "Welches Schloss soll ich wählen, Elektronikschloss oder mit Schlüssel?",
			pl: "Jaki zamek wybrać - elektroniczny czy z kluczem?",
		},
		answerByLanguage: {
			de: (
				<>
					<p>
						Prinzipiell kann man diese Fragen nicht beantworten- es entscheidet die
						persönliche Vorliebe.
					</p>
					<p>
						Der Trend geht allerdings klar zu elektronischen Schlössern. Man muss keine
						unhandlichen Tresorschlüssel mitführen, somit kann auch von eine
						außenstehend am Schlüsselbund nicht erkannt werden, dass Sie einen Tresor zu
						Hause haben. Einbrecher, die einen Tresor mit Schlüsselschloss finden,
						neigen dazu, die Wohnung nach dem passenden Schlüssel zu durchsuchen.
					</p>
				</>
			),
			pl: (
				<>
					<p>
						W zasadzie na te pytania nie da się odpowiedzieć - decydują o tym Państwa
						osobiste preferencje.
					</p>
					<p>
						Jednak trend wyraźnie zmierza w kierunku zamków elektronicznych. Nie trzeba
						wtedy nosić przy sobie nieporęcznych kluczy do sejfu. Poza tym włamywacze,
						którzy znajdują sejf z zamkiem kluczowym, zwykle przeszukują mieszkanie w
						poszukiwaniu pasującego klucza.
					</p>
				</>
			),
		},
	},
	{
		questionByLanguage: {
			de: "Welche Tresor-Marke soll ich wählen?",
			pl: "Jaką markę sejfu wybrać?",
		},
		answerByLanguage: {
			de: (
				<>
					<p>
						Wir haben alle namhaften Hersteller selektiert und auf unserer Seite „Tresor
						Marken“ abgebildet. Sie können aber auch gerne eine Beratung in Anspruch
						nehmen:
					</p>
					<p>
						<Link href="/help/contact">Kontakt</Link>
					</p>
				</>
			),
			pl: (
				<>
					<p>
						Wybraliśmy wszystkich renomowanych producentów i umieściliśmy ich na naszej
						stronie „Bezpieczny marki„ strona. Jednak zapraszamy również do skorzystania
						z konsultacji rada:
					</p>
					<p>
						<Link href="/help/contact">Kontakt</Link>
					</p>
				</>
			),
		},
	},
]

export const assemblyFAQs = [
	{
		questionByLanguage: {
			de: "Kann ich den Tresor verankern lassen?",
			pl: "Czy mogę sam zakotwiczyć sejf?",
		},
		answerByLanguage: {
			de: (
				<>
					<p>
						Wir bieten Ihnen gerne an, den Tresor im Zuge der Lieferung fachgerecht zu
						verankern. Ihr Tresor wird mit einer Spezial-Spedition geliefert und durch 2
						Mann an die Verwendungsstelle vertragen. Nach erfolgter Montage stellen die
						Mitarbeiter eine sogenannte Konformitäts-Erklärung aus. Diese Bescheinigung
						wird häufig von Versicherungen gefordert, da Sie die fach- und sachgerechte
						Verankerung bescheinigt.
					</p>
					<p>
						Natürlich kann die Montage durch Schwerlastanker auch problemlos von
						Hobby-Heimwerkern selbst durchgeführt werden. Das benötigte Material liegt
						im Regelfall dem Tresor bei. Zu beachten gilt, dass sie ggf. eine
						Konformitätserklärung für Ihre Versicherung benötigen. Gerne können Sie uns
						diesbezüglich kontaktieren!
					</p>
					<p>
						<Link href="/help/delivery">Lieferung und Montage</Link>
					</p>
				</>
			),
			pl: (
				<>
					<p>
						Oczywiście montaż za pomocą wytrzymałych kotew może być bez problemu
						przeprowadzony również przez majsterkowiczów-amatorów. Potrzebne materiały
						są zazwyczaj dołączone do sejfu.
					</p>
				</>
			),
		},
	},
	{
		questionByLanguage: {
			de: "Was ist bei der Verankerung eines Tresors zu beachten?",
			pl: "Na co należy zwrócić uwagę przy kotwiczeniu sejfu?",
		},
		answerByLanguage: {
			de: (
				<>
					<p>
						Tresore können je nach Modell entweder an der Wand, im Boden oder an Beiden
						befestigt werden. Wichtig ist, dass der Untergrund oder die Wand eine solide
						Befestigung ermöglicht. Im Idealfall handelt es sich dabei um Beton. Bei
						Ziegel- oder Steinwänden, kommt es nämlich häufig vor, dass die Stabilität
						des Bohrloches nicht ausreicht. In diesem Fällen kann mit der Verwendung von
						sogenannten Klebeankern nachgeholfen werden. Eine Montage auf Trocken- oder
						Leichtbauwänden (Rigips, Holz, Ytong) sowie auf Holzdecken ist für
						Versicherungen leider nicht zulässig. Weiters sollte beachtet werden, dass
						sich keine Fußbodenheizung, Wasser- oder Stromleitung in der Nähe der
						Bohrung befinden. Gegebenenfalls müssen Sockelleisten entfernt werden, dass
						der Tresor bündig am Boden und der Wand ist.
					</p>
					<p>
						Eine Befestigung ist bis zu einem Tresorgewicht von 1000 kg von
						Versicherungen vorgeschrieben!
					</p>
				</>
			),
			pl: (
				<>
					<p>
						Sejfy mogą być mocowane do ściany, podłogi lub obu tych elementów, w
						zależności od modelu. Ważne jest, aby podłoże lub ściana pozwalały na
						solidne zamocowanie. Najlepiej, aby był to beton. W przypadku ścian z cegły
						lub kamienia często zdarza się, że stabilność wywierconego otworu nie jest
						wystarczająca. W tym przypadku pomocne może być zastosowanie tzw. kotew
						wklejanych. Niestety montaż na suchych lub lekkich ścianach
						(gipsowo-kartonowych, drewnianych, Ytong), a także na drewnianych sufitach
						jest niedopuszczalny dla firm ubezpieczeniowych. Ponadto należy upewnić się,
						że w pobliżu otworu nie znajdują się rury ogrzewania podłogowego, wody lub
						prądu. W razie potrzeby należy usunąć listwy przypodłogowe, tak aby sejf
						znajdował się w jednej płaszczyźnie z podłogą i ścianą.
					</p>
					<p>
						Mocowanie jest zalecane przez firmy ubezpieczeniowe dla sejfów o wadze do
						1000 kg!
					</p>
				</>
			),
		},
	},
	{
		questionByLanguage: {
			de: "Ab welchem Gewicht kann ich einen Tresor nicht mehr selber transportieren?",
			pl: "Od jakiej wagi sejfu nie mogę już samodzielnie transportować?",
		},
		answerByLanguage: {
			de: (
				<p>
					Das kommt natürlich auf Ihre körperliche Verfassung an, in der Regel kann ein
					durchschnittlich gebauter Mann einen Tresor bis zu einem Gewicht von 55 kg
					alleine vertragen. Mit verschiedenen Transporthilfen („Sackrolli“,
					Treppensteiger oder einem freundlichen Bekannten) kann ein Tresor bis zu ca. 180
					kg selbst vertragen werden. Bei vielen Modellen ist es möglich die Tresortür
					auszuhängen und somit die Vertragung zu vereinfachen.
				</p>
			),
			pl: (
				<p>
					Oczywiście zależy to od kondycji fizycznej. Z reguły przeciętnie zbudowany
					mężczyzna może samodzielnie unieść sejf ważący do 55 kg. Dzięki różnym pomocom
					transportowym można samodzielnie przenosić sejf o wadze do ok. 180 kg. W wielu
					modelach możliwe jest zdemontowanie drzwi sejfu, co zdecydowanie ułatwia jego
					wniesienie.
				</p>
			),
		},
	},
	{
		questionByLanguage: {
			de: "Kann ich Tresore auch mit Türanchlag links bestellen?",
			pl: "Czy mogę zamówić sejf z zawiasem drzwiowym po lewej stronie?",
		},
		answerByLanguage: {
			de: (
				<>
					<p>
						Manche Tresore, vor allem in höheren Sicherheitsklassen, werden
						„just-in-time“ gefertigt, daher können Sie einen Türanschlag links
						bestellen. In unseren umfangreichen Filtermöglichkeiten finden Sie unter
						Sonstiges den Punkt &quot;Türanschlag&quot;. Damit werden Ihnen sämtliche
						Modelle, bei denen eine Änderung des Türanschlages möglich ist, aufgelistet.
						Gerne beraten wir Sie dazu auch persönlich:
					</p>
					<p>
						<Link href="/help/contact">Kontakt</Link>
					</p>
				</>
			),
			pl: (
				<>
					<p>
						Niektóre sejfy, zwłaszcza w wyższych klasach odporności, produkowane są
						"just in time", dlatego można zamówić zawias do drzwi z lewej strony.
					</p>
					<p>
						<Link href="/help/contact">Kontakt</Link>
					</p>
				</>
			),
		},
	},
]

export const problemFAQs = [
	{
		questionByLanguage: {
			de: "Was passiert wenn ich Schlüssel oder Code verloren habe?",
			pl: "Co się stanie, jeśli zgubię klucz lub kod?",
		},
		answerByLanguage: {
			de: (
				<p>
					Bei einem verlorenen Schlüssel bleibt in den meisten Fällen nur mehr die Hilfe
					vom Spezialisten. Leider müssen wir vorwegnehmen, dass bei vielen Tresoren sich
					eine gewaltfreie Schlossöffnung nicht auszahlt, da diese zumeist teurer ist wie
					ein neuer Tresor. Bei hochwertigen Elektronikschlössern gibt es einen
					mechanischen Notschlüssel. Wenn weder Notschlüssel, noch Zugangscode vorhanden
					sind, bleibt ebenfalls nur mehr die Hilfe von einem Spezialisten.
				</p>
			),
			pl: (
				<p>
					W przypadku utraty klucza najczęściej pozostaje już tylko pomoc specjalisty.
					Niestety w wielu sejfach nie opłaca się otwieranie zamka bez użycia siły,
					ponieważ jest to zazwyczaj droższe niż nowy sejf. W przypadku wysokiej jakości
					zamków elektronicznych pomocny jest awaryjny klucz mechaniczny. Jeśli nie ma ani
					klucza awaryjnego, ani kodu dostępu, pozostaje również tylko pomoc specjalisty.
				</p>
			),
		},
	},
	{
		questionByLanguage: {
			de: "Was passiert bei einem technischen Defekt des Tresors?",
			pl: "Co dzieje się w przypadku wystąpienia usterki technicznej sejfu?",
		},
		answerByLanguage: {
			de: (
				<p>
					Da wir ausschließlich Produkte von hoher Qualität verkaufen, sollten Sie diesen
					Service nicht benötigen. Wenn doch einmal etwas passieren sollte, haben wir
					national und international Fachpartner, die Ihnen schnell und unkompliziert
					helfen, wenn es einmal zu einem Problem kommt.
				</p>
			),
			pl: (
				<p>
					Ponieważ sprzedajemy tylko produkty wysokiej jakości, nie powinieneś potrzebować
					pomocy serwisu. Gdyby jednak coś się wydarzyło, mamy krajowych i
					międzynarodowych wyspecjalizowanych partnerów, którzy w razie problemów pomogą
					Ci go szybko rozwiązać.
				</p>
			),
		},
	},
	{
		questionByLanguage: {
			de: "Wie werden Reklamationen behandelt?",
			pl: "Jak rozpatrywane są reklamacje?",
		},
		answerByLanguage: {
			de: (
				<>
					<p>
						Sie können innerhalb der gesetzlichen Widerrufsfrist das Recht, den Tresor
						an uns zurückzusenden. Sollte es sich um ein technisches Problem handeln,
						helfen wir Ihnen natürlich gerne weiter und versuchen das Problem
						schnellstmöglich zu beheben. In solchen Fällen kontaktieren Sie uns einfach:
					</p>
					<p>
						<Link href="/help/contact">Kontakt</Link>
					</p>
				</>
			),
			pl: (
				<>
					<p>
						Mają Państwo prawo zwrócić nam sejf w ustawowym terminie odstąpienia od
						umowy. Jeśli jest to problem techniczny, oczywiście chętnie pomożemy i
						postaramy się jak najszybciej usunąć problem. W takich przypadkach wystarczy
						skontaktować się z nami.
					</p>
					<p>
						<Link href="/help/contact">Kontakt</Link>
					</p>
				</>
			),
		},
	},
]
